import { render, staticRenderFns } from "./AtualizarCadastro.vue?vue&type=template&id=5a101744&scoped=true"
import script from "./AtualizarCadastro.vue?vue&type=script&lang=js"
export * from "./AtualizarCadastro.vue?vue&type=script&lang=js"
import style0 from "./AtualizarCadastro.vue?vue&type=style&index=0&id=5a101744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a101744",
  null
  
)

export default component.exports